const InternalMenu =  [
  { header: 'INTERNAL MANAGEMENT MENU' },
  // {
  //   title: 'Dashboard',
  //   group: 'InternalMenu',
  //   icon: 'dashboard',
  //   name: 'Dashboard',
  // },
  {
    title: 'Daftar Admin',
    group: 'MENU',
    icon: 'fas fa-key',
    // target: '_blank',
    name: 'DaftarAdmin',
  },
  // {
  //   title: 'Daftar List Tutor',
  //   group: 'MENU',
  //   icon: 'fas fa-chalkboard-teacher',
  //   // target: '_blank',
  //   name: 'DaftarListTutor',
  // },
  // {
  //   title: 'Daftar List Mahasiswa',
  //   group: 'MENU',
  //   icon: 'fas fa-user-graduate',
  //   // target: '_blank',
  //   name: 'DaftarListMahasiswa',
  // },
];

// reorder menu
InternalMenu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default InternalMenu;
